import { get, post } from './http';

export const getProducts = async (products, channelId) => {
  const response = await get(
    `/api/shoppinglist?products=${products}&channelId=${channelId}`
  );
  return response.json();
};

export const getOrganizations = async (channelId) => {
  const response = await get(
    `/api/shoppinglist/getorganizations?channelId=${channelId}`
  );
  return response.json();
};

export const postInquire = async (body) => {
  const response = await post(`/api/shoppinglist/sendinquire`, body);
  return response.status == 200;
};
